import { Point } from '@pacem/pacem-foundation';
import { Utils } from '../utils';
import { CustomUIEvent } from '../events';
//namespace Pacem.UI {
export var DragDataMode;
(function (DragDataMode) {
    /** Source element is dragged around (floater is the element itself so is the data). */
    DragDataMode["Self"] = "self";
    /** The floater is an element clone, while data is the element itself.  */
    DragDataMode["Alias"] = "alias";
    /** The floater is a clone of the element, while data is a copy of it. */
    DragDataMode["Copy"] = "copy";
})(DragDataMode || (DragDataMode = {}));
export var DropBehavior;
(function (DropBehavior) {
    /** Drag & drop task is meant to sort or swap items around. */
    DropBehavior["InsertChild"] = "insert";
    /** Drag & drop task has no logical meaning. Event listeners might be in charge for a specific scenario.  */
    DropBehavior["None"] = "none";
})(DropBehavior || (DropBehavior = {}));
export var DropTargetMissedBehavior;
(function (DropTargetMissedBehavior) {
    /** Reverts to the last tracked spot. */
    DropTargetMissedBehavior["Revert"] = "revert";
    /** Deletes item on spill-out. */
    DropTargetMissedBehavior["Remove"] = "remove";
    /** No explicit behavior, might fallback to 'revert' when drop behavior is 'insert'.  */
    DropTargetMissedBehavior["None"] = "none";
})(DropTargetMissedBehavior || (DropTargetMissedBehavior = {}));
export var DragDropEventType;
(function (DragDropEventType) {
    /** Initial state change before first dragging act. */
    DragDropEventType["Init"] = "draginit";
    /** First dragging act. */
    DragDropEventType["Start"] = "dragstart";
    /** Any dragging act. */
    DragDropEventType["Drag"] = "drag";
    /** Dropping act. */
    DragDropEventType["Drop"] = "drop";
    /** Hovering a drop target. */
    DragDropEventType["Over"] = "dragover";
    /** Exiting a drop target. */
    DragDropEventType["Out"] = "dragout";
    /** Terminating the drag-drop activities. */
    DragDropEventType["End"] = "dragend";
})(DragDropEventType || (DragDropEventType = {}));
class DragDropEventArgsBaseClass {
    constructor(_builder) {
        this._builder = _builder;
        this.currentPosition = _builder.currentPosition;
        this.target = _builder.target;
    }
    get element() {
        return this._builder.element;
    }
    get origin() {
        return this._builder.origin;
    }
    get initialDelta() {
        return this._builder.initialDelta;
    }
    get startTime() {
        return this._builder.startTime;
    }
    get floater() {
        return this._builder.floater;
    }
    get delta() {
        var args = this;
        return Point.add(args.initialDelta, /* included in `initialDelta` for perf sake => { x: this._builder.scroll.left, y: this._builder.scroll.top },*/ Point.subtract(args.origin, args.currentPosition));
    }
}
export class DragDropInitEventArgsClass extends DragDropEventArgsBaseClass {
    constructor(_builder) {
        super(_builder);
        this.placeholder = _builder.placeholder;
        this.data = _builder.data;
    }
    static fromArgs(builder) {
        return new DragDropInitEventArgsClass(Utils.extend({}, builder));
    }
}
export class DragDropEventArgsClass extends DragDropEventArgsBaseClass {
    constructor(_builder, _placeholder = _builder.placeholder, _data = _builder.data) {
        super(_builder);
        this._placeholder = _placeholder;
        this._data = _data;
    }
    get placeholder() {
        return this._placeholder;
    }
    get data() {
        return this._data;
    }
    static fromArgs(builder) {
        return new DragDropEventArgsClass(Utils.extend({}, builder));
    }
}
export class DragDropEvent extends CustomUIEvent {
    constructor(type, args, eventInit, evt) {
        super(type, args, eventInit, evt);
    }
}
//}
